import React from 'react'
import { Global, css } from '@emotion/react'
import mq from './mediaQueries'

export default () => (
  <Global styles={
    css`
      @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');

      body, html, #root {
        font-family: 'Roboto', 'Helvetica Neue', Helvetica, Aria, sans-serif;
        background-color: #eef1f6;
        color: #48545f !important;
        height: 100%;
        margin: 0;
        padding: 0;
        width: 100%;
      }

      a {
        color: #48545f;
      }

      .MuiAutocomplete-option {
        &[data-focus="true"] {
          background-color: #007bff;
          color: #ffffff;
        }
      }
    `
  }
  />
)

export const mobile = css(mq({
  display: ['block', 'block', 'none', 'none'],
}))

export const desktop = css(mq({
  display: ['none', 'none', 'block', 'block'],
}))
